<template>
  <div id="app" :class="{ 'app--embedded': embedded }">
    <div class="app-theme-bg"></div>
    <div class="app-theme-wash"></div>
    <div class="app-header-layer">
      <app-header v-if="headerShow && !embedded"></app-header>
    </div>
    <div class="app-page">
      <router-view @eventShow="show"></router-view>
    </div>
  </div>
</template>


<script>
import Header from "./components/Header";
import { isEmbedded } from './service/embed-mode';
import center from './service/center';
import { reportEmbeddedRoute } from './service/platform-token-bridge';

export default {
  components: {
    'app-header': Header
  },

  data () {
    return {
      // 登录页和 SSO 票据兑换页首先挂载。默认创建 Header 会在本地
      // JWT 写入前请求消息接口，产生一次误导性的“userId为空”。
      headerShow: false,
      embedded: isEmbedded
    }
  },
  watch: {
    '$route.fullPath': {
      immediate: true,
      handler() { if (this.embedded) reportEmbeddedRoute(this.$route.path, this.$route.query.id) }
    }
  },
  mounted() {
    this._boardHome = () => {
      if (this.embedded && this.$route.path !== '/index') this.$router.push('/index')
    }
    center.$on('board-home', this._boardHome)
  },
  beforeDestroy() { center.$off('board-home', this._boardHome) },
  methods: {
    show (bool = true) {
      this.headerShow = bool
    },
  }
};
</script>

<style scoped>
#app {
  width: 100%;
  min-height: 100vh;
  overflow: auto;
  position: relative;
  background-color: var(--c-panel-solid);
}
.app-theme-bg,
.app-theme-wash {
  z-index: 0;
}
.app-header-layer {
  position: relative;
  z-index: 50;
}
.app-page {
  position: relative;
  z-index: 1;
}
</style>

<style>
/* 只作用于嵌入模式，独立前台保留原有标题、账号入口和尺寸。 */
.app--embedded .project-page { width: 100% !important; min-width: 1100px; height: calc(100vh - 40px) !important; min-height: 650px; padding: 12px 20px 0 !important; box-sizing: border-box; }
.app--embedded .index-page > .container { width: 100% !important; }
.app--embedded .index-page .search-box-box { height: calc(100vh - 32px); margin-top: 16px; padding-left: 16px; }
.embed-home { position: relative; z-index: 10; margin: 6px 16px; padding: 5px 12px; border: 1px solid var(--c-primary); color: var(--c-text); background: var(--c-panel-solid); cursor: pointer; }
</style>



// WEBPACK FOOTER //
// src/App.vue